var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInAppHccIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_2108",
    "data-name": "Group 2108",
    transform: "translate(-1243 -1308)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 30,
    cy: 30,
    r: 30,
    transform: "translate(1243 1308)",
    fill: "#7dbaab"
  }), /*#__PURE__*/React.createElement("g", {
    id: "_24-hours",
    "data-name": "24-hours",
    transform: "translate(1248.544 1314.151)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3455",
    "data-name": "Path 3455",
    d: "M24.791,4A18.443,18.443,0,0,0,7.126,17.322a2.145,2.145,0,0,1,2.346,1.737A15.386,15.386,0,0,0,22.665,31.89V31.21a2.139,2.139,0,0,1,3.3-1.765l8.84,5.891a2.153,2.153,0,0,1,.943,1.808C49.779,26.653,42.527,4.114,24.791,4Zm9.91,7.465.723-.723a.707.707,0,1,1,1,1c-.281.229-.8.984-1.219.936a.716.716,0,0,1-.5-1.212Zm-19.821,1a.694.694,0,0,1-1,0c-.408-.45-1.36-1.049-.723-1.723a.706.706,0,0,1,1,0c.408.45,1.36,1.049.723,1.723ZM22.962,26.02a.709.709,0,1,1,0,1.418H16.993a.712.712,0,0,1-.489-1.219l5.1-4.92c2.186-2.283-1.2-5.2-3.389-3.2l-.723.7a.71.71,0,0,1-.985-1.021,4.523,4.523,0,0,1,3.4-1.772,3.7,3.7,0,0,1,2.679,6.309l-3.835,3.7ZM25.5,7.653a.709.709,0,1,1-1.418,0V6.632a.709.709,0,1,1,1.418,0Zm7.089,17.786h-.312v1.29a.709.709,0,1,1-1.418,0v-1.29H26.585a.715.715,0,0,1-.6-1.085l4.984-8.011a.714.714,0,0,1,1.311.376v7.3h.312a.709.709,0,1,1,0,1.418Zm3.835,8.578a.712.712,0,0,1-1,0c-.412-.452-1.36-1.053-.723-1.73a.706.706,0,0,1,1,0c.412.452,1.36,1.053.723,1.73Zm4.112-10.931H39.515a.709.709,0,1,1,0-1.418h1.021a.709.709,0,1,1,0,1.418Z",
    transform: "translate(-0.304)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3456",
    "data-name": "Path 3456",
    d: "M33.718,42.562l-8.84-5.891a.714.714,0,0,0-1.1.588v2.226A16.876,16.876,0,0,1,7.793,25.464a.717.717,0,0,0-1.418-.107C4.367,36,12.966,46.614,23.779,46.794v2.247a.711.711,0,0,0,1.1.588l5.877-3.913,2.963-1.978a.707.707,0,0,0,.312-.588.734.734,0,0,0-.312-.588Z",
    transform: "translate(0 -6.05)",
    fill: "#fafafa"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3457",
    "data-name": "Path 3457",
    d: "M39.375,30.263V25.442l-3,4.821Z",
    transform: "translate(-8.818 -6.241)",
    fill: "#fafafa"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInAppHccIcon);
export default __webpack_public_path__ + "static/media/in-app-hcc-icon.58d99837eeb4da6d83a3537f00436bcd.svg";
export { ForwardRef as ReactComponent };